/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Card_Updated_SuccessInputs */

const en_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment method has been updated successfully.`)
};

const fr_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre mode de paiement a été mis à jour avec succès.`)
};

const de_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Zahlungsmethode wurde erfolgreich aktualisiert.`)
};

const it_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo metodo di pagamento è stato aggiornato con successo.`)
};

const ru_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш способ оплаты успешно обновлен.`)
};

const es_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su método de pago ha sido actualizado exitosamente.`)
};

const zh_cn2_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的付款方式已成功更新。`)
};

const ja_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払い方法が正常に更新されました。`)
};

const hi_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी भुगतान विधि सफलतापूर्वक अपडेट कर दी गई है।`)
};

const pt_pt2_card_updated_success = /** @type {(inputs: Card_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu método de pagamento foi atualizado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Your payment method has been updated successfully." |
*
* @param {Card_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const card_updated_success = /** @type {((inputs?: Card_Updated_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Card_Updated_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_card_updated_success(inputs)
	if (locale === "de") return de_card_updated_success(inputs)
	if (locale === "it") return it_card_updated_success(inputs)
	if (locale === "ru") return ru_card_updated_success(inputs)
	if (locale === "es") return es_card_updated_success(inputs)
	if (locale === "zh-CN") return zh_cn2_card_updated_success(inputs)
	if (locale === "ja") return ja_card_updated_success(inputs)
	if (locale === "hi") return hi_card_updated_success(inputs)
	if (locale === "pt-PT") return pt_pt2_card_updated_success(inputs)
	return en_card_updated_success(inputs)
});